<template>
  <div id="course-create-details-tab">
    <div class="vx-col w-full">
        <div class="vx-row ">
          <div class="vx-col lg:w-1/3 sm:w-1/1 w-full mb-2 ">
              <vs-input class="w-full" label-placeholder="Course Name" v-model="dataLocal.course_name" @change="courseUpdateData"/>
          </div>
          <div class="vx-col lg:w-1/3 sm:w-1/2 w-full mb-2 ">
            <vs-select class="w-full mt-5" placeholder="Course Status" v-model="dataLocal.status"  @change="courseUpdateData">
              <vs-select-item :key="index" :value="option" :text="option.charAt(0).toUpperCase() + option.slice(1)" v-for="(option,index) in status_options"/>
            </vs-select>
          </div>
          <div class="vx-col lg:w-1/3 sm:w-1/2 w-full mb-2 ">
            <vs-input class="w-full" label-placeholder="Course Code" v-model="dataLocal.course_code" @change="courseUpdateData"/>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full mt-2">
            <vs-textarea  label="Course Description" counter="400" :counter-danger.sync="course_description_counter" height="100px" v-model="dataLocal.course_description" @change="courseUpdateData"/>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button color="success" type="filled" class="mb-2 mr-2"
                       @click="submitData">Create Course
            </vs-button>
            <vs-button color="warning" type="border" class="mb-2 ml-2"
                       @click="resetData">Reset
            </vs-button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      retailer_options: [],
      course_description_counter: null,

      status_options: [
        'active',
        'hidden',
        'disabled'
      ]

    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    courseUpdateData () {
      this.$emit('update_courseData', this.dataLocal)
    },
    submitData () {
      this.$emit('insert_courseData', this.dataLocal)
    },
    resetData () {
      this.dataLocal =  {course_name: undefined, course_description: undefined, course_status: undefined, course_code : undefined}
      this.courseUpdateData()
    }
  }
}
</script>

<style scoped>

</style>
